export default "__VITE_ASSET__phgqKad0__"